import http from '@/utils/http';

/**
 * 获取体检次数时间变化
 */
export const getTimeDay = () => {
    return http({
        url: '/api/area/v2/checkup/timeday',
        method: 'get'
    });
};







